import * as React from 'react';
const SvgInfinity = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 36 36" fill="none" {...props}>
        <circle cx={18} cy={18} r={18} fill="url(#infinity_svg__paint0_linear)" />
        <path
            d="M16 15.354l.753-.657-.003-.005-.75.662zm.75 5.954a1 1 0 10-1.5-1.324l1.5 1.324zM13 21a3 3 0 01-3-3H8a5 5 0 005 5v-2zm-3-3a3 3 0 013-3v-2a5 5 0 00-5 5h2zm3-3c.896 0 1.7.391 2.25 1.016l1.5-1.324A4.99 4.99 0 0013 13v2zm2.25 4.984A2.99 2.99 0 0113 21v2a4.99 4.99 0 003.75-1.692l-1.5-1.324zm-.003-3.972c.31.354 1.149 1.384 1.92 2.543l1.665-1.11a29.961 29.961 0 00-2.079-2.748l-1.506 1.315zM20 20.646l-.753.657.003.005.75-.662zm-.75-5.954a1 1 0 101.5 1.324l-1.5-1.324zM23 15a3 3 0 013 3h2a5 5 0 00-5-5v2zm3 3a3 3 0 01-3 3v2a5 5 0 005-5h-2zm-3 3a2.99 2.99 0 01-2.25-1.016l-1.5 1.324A4.99 4.99 0 0023 23v-2zm-2.25-4.984A2.99 2.99 0 0123 15v-2a4.99 4.99 0 00-3.75 1.692l1.5 1.324zm.003 3.972a27.998 27.998 0 01-1.92-2.543l-1.665 1.11a29.961 29.961 0 002.079 2.748l1.506-1.315z"
            fill="#fff"
        />
        <defs>
            <linearGradient
                id="infinity_svg__paint0_linear"
                x1={0}
                y1={0}
                x2={43.321}
                y2={15.383}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5449A1" />
                <stop offset={0} stopColor="#594EAB" />
                <stop offset={1} stopColor="#804ED9" />
            </linearGradient>
        </defs>
    </svg>
);
export default SvgInfinity;
